<template>
  <v-btn text small @click.stop="goBack" color="primary">
    <v-icon class="mr-1">chevron_left</v-icon>
    {{ text }}
  </v-btn>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "Enrera",
    },
  },
  methods: {
    goBack() {
      window.history.back()
    },
  },
}
</script>

<style scoped></style>
